<template>
  <v-container class="text-center">
    <v-row>
      <v-col
        v-for="({ icon, title, text }, i) in features"
        :key="i"
        cols="12"
        md="4"
        style="padding-top: 60px;"
      >
          <v-theme-provider dark>
            <div>
              <v-avatar
                color="primary"
                size="88"
              >
                <v-icon
                  large
                  v-text="icon"
                ></v-icon>
              </v-avatar>
            </div>
          </v-theme-provider>

          <v-card-title
            class="justify-center font-weight-black text-uppercase"
            v-text="title"
          ></v-card-title>

          <v-card-text
            class="headline"
            v-text="text"
          >
          </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Services',

    data: () => ({
      features: [
          {
            icon: 'free_breakfast',
            title: 'Café',
            text: 'Disponemos de un café que no te dejará indiferente. Tiene una textura y sabor exquisito. ',
          },
          {
            icon: 'local_dining',
            title: 'Bar',
            text: 'Pequeño bar que te hará sentir en casa.   Rodeado de un ambiente acogedor y familiar. ',
          },
          {
            icon: 'cake',
            title: 'Postres',
            text: 'Tenemos una selección de dulces para todos los gustos. Un capricho nunca sienta mal. ',
          },
        ]
    }),
  }
</script>
